module.exports = __webpack_public_path__ + "static/integration/d2l/d2l.b87f21f5926e7c65abd8fa80a9657f1b.css";